import { AppState } from '../root.reducer';

export const getOrderAmountRemaining = (state: AppState) => state.order.amountRemaining;

export const getOrderAmountRemainingOrderId = (state: AppState) => state.order.amountRemainingOrderId;

export const getOrderAmountRemainingForOrder = (orderId?: string) => (state: AppState) => {
  if (!orderId) {
    return undefined;
  }

  return state.order.amountRemainingByOrderId[orderId];
};
